import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { useLocation } from "react-router-dom";

import { Box, Button, Link } from "@mui/material";

import LogoText from "components/common/LogoText";
import LoginIcon from "icons/Login";

import { LINKS } from "@constants";

import eventsService, { EVENTS } from "services/events";
import { MenuItemStyled } from "./styles";

const DesktopHeader = ({ pages }) => {
  const location = useLocation();
  const path = location.pathname;

  const trackRedirect = () => {
    eventsService.track(EVENTS.BTB_CTA, {
      place: "landing_for_business",
    });
  };

  return (
    <Box
      sx={{
        display: { sm: "none", xs: "none", md: "flex" },
        gap: "48px",
        flexGrow: 1,
        alignItems: "center",
      }}
    >
      <LogoText showMobileLogo />
      <Box
        sx={{ flexGrow: 1, display: { xs: "none", md: "flex", gap: "40px" } }}
        role="navigation"
        component="nav"
      >
        {pages.map(({ label, href }) => (
          <MenuItemStyled
            key={label}
            as={Link}
            href={href}
            className={classNames({ active: path === href })}
          >
            {label}
          </MenuItemStyled>
        ))}
        <MenuItemStyled
          as={Link}
          href={LINKS.respeecherForBusiness}
          onClick={trackRedirect}
          target="_blank"
          rel="noopener noreferrer"
        >
          <LoginIcon /> For Business
        </MenuItemStyled>
      </Box>
      <Button component={Link} href={LINKS.signup} variant="contained">
        Try For Free
      </Button>
      <Button
        component={Link}
        href={LINKS.login}
        startIcon={<LoginIcon />}
        variant="outlined"
      >
        Log In
      </Button>
    </Box>
  );
};

DesktopHeader.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default DesktopHeader;
